import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { Bell, CheckCheck, Check } from "lucide-react";

const KIND_STYLES = {
  approval: "bg-[#FBEAED] text-[#8A0822]",
  blocker: "bg-[#FDF2F4] text-[#8A0822]",
  comment: "bg-[#EAF1FB] text-[#1F4E9B]",
  intake: "bg-[#ECF8F1] text-[#1A5633]",
  task: "bg-[#F4F6FA] text-[#5A687C]",
  info: "bg-[#F4F6FA] text-[#5A687C]",
};

export default function Notifications() {
  const nav = useNavigate();
  const [notifs, setNotifs] = useState([]);
  const [filter, setFilter] = useState("all");
  const load = () => api.get("/notifications").then((r) => setNotifs(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const markRead = async (id) => { await api.post(`/notifications/${id}/read`); load(); };
  const markAll = async () => { await api.post("/notifications/read-all"); load(); };
  const open = async (n) => { if (!n.read) await api.post(`/notifications/${n.id}/read`); if (n.link) nav(n.link); else load(); };
  const shown = notifs.filter((n) => filter === "all" || !n.read);
  const unread = notifs.filter((n) => !n.read).length;

  return (
    <div className="space-y-6">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h1 className="text-2xl lg:text-3xl font-extrabold text-[#1F2733] flex items-center gap-2"><Bell className="h-6 w-6 text-[#BA0C2F]" /> Notifications</h1>
          <p className="text-[#5A687C] mt-1">{unread} unread · {notifs.length} total</p>
        </div>
        <button data-testid="mark-all-read-btn" onClick={markAll} className="inline-flex items-center gap-1.5 bg-[#1F2733] hover:bg-[#0f141b] text-white rounded-full px-5 py-2.5 font-semibold text-sm"><CheckCheck className="h-4 w-4" /> Mark all read</button>
      </div>

      <div className="flex gap-1.5 bg-[#F4F6FA] p-1.5 rounded-full border border-[#DCE2EA] w-fit">
        {["all", "unread"].map((f) => (
          <button key={f} data-testid={`notif-filter-${f}`} onClick={() => setFilter(f)}
            className={`px-4 py-1.5 rounded-full text-sm capitalize transition-all ${filter === f ? "bg-[#BA0C2F] text-white font-semibold" : "text-[#5A687C] hover:bg-white/70 font-medium"}`}>{f}{f === "unread" ? ` (${unread})` : ""}</button>
        ))}
      </div>

      <div className="bg-white rounded-[18px] border border-[#DCE2EA] divide-y divide-[#DCE2EA]/60 overflow-hidden" data-testid="notifications-list">
        {shown.length === 0 && <div className="p-10 text-center text-[#5A687C]">{filter === "unread" ? "You're all caught up." : "No notifications yet."}</div>}
        {shown.map((n) => (
          <div key={n.id} data-testid={`notification-${n.id}`} className={`flex items-center gap-3 p-4 ${n.read ? "opacity-60" : "bg-[#FBEAED]/20"}`}>
            {!n.read && <span className="h-2 w-2 rounded-full bg-[#BA0C2F] shrink-0" />}
            <span className={`text-[10px] font-bold uppercase px-2 py-0.5 rounded-full shrink-0 ${KIND_STYLES[n.kind] || KIND_STYLES.info}`}>{n.kind}</span>
            <button onClick={() => open(n)} className="flex-1 min-w-0 text-left">
              <div className="text-sm text-[#1F2733]">{n.message}</div>
              <div className="text-[11px] text-[#98A2AF] mt-0.5">{new Date(n.created_at).toLocaleString()}</div>
            </button>
            {!n.read && <button data-testid={`mark-read-${n.id}`} onClick={() => markRead(n.id)} className="text-[#98A2AF] hover:text-[#BA0C2F] shrink-0" title="Mark read"><Check className="h-4 w-4" /></button>}
          </div>
        ))}
      </div>
    </div>
  );
}
